import styled from "styled-components";
import media from "../../../../styles/media";
import loadingGif from "../../../../assets/images/loading.gif";

export const VideoWrapper = styled.div`
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	overflow: hidden;
	width: 100%;
	position: relative;
	aspect-ratio: 16 / 9;
	min-height: 300px;

	${media.lessThan("medium")`
		min-height: 250px;
	`}

	/* ReactPlayer wrapper */
	> div {
		position: absolute !important;
		top: 0;
		left: 0;
		width: 100% !important;
		height: 100% !important;
	}

	iframe,
	video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
		pointer-events: auto;
	}

	&:after {
		display: none;
		content: "";
		background: url(${loadingGif}) no-repeat center white;
		background-size: 80px;
		z-index: 1;
		opacity: 0;
		transition: opacity 0.3s ease;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	&.loading:after {
		opacity: 1;
	}
`;
